<template>
    <div v-if="form.status !== 1 && form.status !== 4 && form.status !== 5 && form.foO_DAT != null" class="invoice-arrived-view detail-card">
        <div class="card-header">
            <div class="title">入帳</div>
            <div class="buttons" v-if="form.status >= 3 || form.incomes.length > 0">
                <div v-if="isActionEnabled" class="button-block">
                    <el-button v-if="form.typ === 4" size="small" type="danger" plain @click="onAddArrival(-1)">
                        新增一筆退款
                    </el-button>
                    <el-button size="small" type="primary" plain @click="onAddArrival(1)">
                        新增一筆入帳
                    </el-button>
                </div>
            </div>
        </div>
        <div class="card-body" v-if="form.status === 2 && form.incomes.length <= 0">
            <el-row :gutter="20">
                <el-col :sm="9">
                    <img class="guide-img" src="@/assets/img/guide-img-01.png" alt="" />
                </el-col>
                <el-col :sm="15">
                    <div class="guide-title">應收帳款尚未入帳</div>
                    <div class="guide-description">
                        營業收入已增加了
                        <Money :v="form.amt" :precision="form.cny === 'TWD' ? null : 4" /><span v-if="form.cny !== 'TWD'"> {{ form.cny }}</span> 元，但銀行帳戶尚未收到此款項，所以實際存款沒有增加。
                    </div>
                    <div v-if="isAuth('B03') && !isQR()" class="guide-actions">
                        <el-button type="primary" @click="onAddArrival(1)">已收到帳款，新增入帳紀錄</el-button>
                        <el-button @click="onCompleteNonIncomeInvoice">應收帳款無法收回，結束此單</el-button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div v-else class="card-body">
            <el-table :data="form.incomes" style="width: 100%; border-top: 1px solid #eee; font-size: 10pt;" size="" empty-text="無入帳資料" :row-class-name="tableRowClassName">
                >
                <el-table-column type="index" label="#" width="35"> </el-table-column>
                <el-table-column prop="bnK_DAT" label="日期" width="95">
                    <template slot-scope="scope">
                        {{ scope.row.bnK_DAT | dateFormater("YYYY-MM-dd") }}
                    </template>
                </el-table-column>
                <el-table-column prop="receiveIncomeType" label="入帳方式" width="115">
                    <template slot-scope="scope">
                        <span class="type">
                            {{ getReceiveIncomeTypeText(scope.row.flg, scope.row.receiveIncomeType) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="account" label="帳戶">
                    <template slot-scope="scope">
                        <div style="padding-right: 12px;">{{ scope.row.bnK_SNO ? scope.row.bnK_TPC : "" }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="mem" label="入帳備註">
                    <template slot-scope="scope">
                        <div v-if="scope.row.mem" class="mem-text" @click="toggleClass($event, 'show-all')">{{ scope.row.mem }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="入帳金額" align="right" width="130">
                    <template slot-scope="scope">
                        <span class="amount">
                            <Money :v="scope.row.flg < 0 ? -scope.row.amount : scope.row.amount" :precision="form.cny === 'TWD' ? null : 4" />
                        </span>
                        <span style="margin-left: 5px">{{ form.cny }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rat" label="匯率" align="right" width="75"> </el-table-column>
                <el-table-column v-if="isActionEnabled" width="50">
                    <template slot-scope="scope">
                        <div v-if="isAuth('B03') && !isQR()" class="edit-btn" @click="onEditArrival(scope.row)">
                            <!-- <div v-for="i in 3" :key="i" /> -->
                            <i class="el-icon-edit"></i>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <DialogBlockWrapper
                :onEdit="onEditBankNote"
                :onSave="onSaveBankNote"
                :onCancel="onCancelEditBankNote"
                :isEditMode="editBankNote.isEditMode"
                :enableEdit="isAuth('B03') && !isQR()"
                style="margin-top: 10px"
            >
                <div v-if="!editBankNote.isEditMode" style="white-space: pre-line">
                    <div style="padding: 0 10px;">
                        <div>
                            <span style="color: #463cb2">帳款備註</span>
                            <div v-if="form.bankNoteUpdateTime > 0 && form.bankNote" style="font-size: 9pt; display: inline-flex; gap: 10px; margin-left: 12px; color: #888;">
                                （{{ form.bankNoteUpdateUser }} {{ form.bankNoteUpdateTime | dateFormater("YYYY-MM-dd") }}）
                            </div>
                        </div>
                        <span>{{ form.bankNote }}</span>
                    </div>
                </div>
                <div v-else>
                    <el-input
                        v-model="editBankNote.value"
                        type="textarea"
                        :autosize="{ minRows: 2, maxRows: 4 }"
                        placeholder="帳款備註內容"
                        maxlength="100"
                        show-word-limit
                    ></el-input>
                </div>
            </DialogBlockWrapper>
            <div class="info-block">
                <div class="total">
                    <div class="title">發票含稅總計</div>
                    <Money :v="form.amt" />
                    <div class="cny">{{ form.cny }}</div>
                </div>
                <div>
                    <div class="title">已收金額</div>
                    <Money :v="totalArrival" />
                    <div class="cny">{{ form.cny }}</div>
                </div>
                <div v-if="form.cny !== 'TWD'">
                    <div class="title">已收金額 (約當台幣)</div>
                    <Money :v="totalArrivalTwd" />
                    <div class="cny">TWD</div>
                </div>
                <div v-if="totalReturn !== 0" class="return">
                    <div class="title">已退金額</div>
                    <Money :v="totalReturn" />
                    <div class="cny">{{ form.cny }}</div>
                </div>
                <div v-if="totalReturn !== 0 && form.cny !== 'TWD'" class="return">
                    <div class="title">已退金額 (約當台幣)</div>
                    <Money :v="totalReturnTwd" />
                    <div class="cny">TWD</div>
                </div>
                <div v-if="totalFutureReturn !== 0" class="return">
                    <div class="title">待退金額</div>
                    <Money :v="totalFutureReturn" />
                    <div class="cny">{{ form.cny }}</div>
                </div>
                <div v-if="totalFutureReturn !== 0 && form.cny !== 'TWD'" class="return">
                    <div class="title">待退金額 (約當台幣)</div>
                    <Money :v="totalFutureReturnTwd" />
                    <div class="cny">TWD</div>
                </div>
                <hr v-if="form.foO_DIS_AMT !== 0" />
                <div v-if="!form.foO_DIS_CNL && form.foO_DIS_AMT !== 0" class="return">
                    <div class="title">
                        <span>銷貨</span>
                        <span v-if="form.foO_DIS === 1">折讓</span>
                        <span v-if="form.foO_DIS === 2">退回</span>
                    </div>
                    <Money :v="form.foO_DIS_AMT" />
                    <div class="cny">{{ form.cny }}</div>
                </div>
                <div class="return" v-if="toBeCreditedAmount !== 0">
                    <div class="title">
                        <span v-if="toBeCreditedAmount > 0">未收金額</span>
                        <span v-if="toBeCreditedAmount < 0">溢收金額</span>
                        <ah-tip>發票含稅總計 - 已收金額 + 已退金額 - 折讓金額</ah-tip>
                    </div>
                    <Money :v="toBeCreditedAmount" abs />
                    <div class="cny">{{ form.cny }}</div>
                </div>
            </div>
        </div>
        <el-dialog :visible="nonIncomeInvoiceVisible" :before-close="onCloseNonIncomeInvoice" :close-on-click-modal="false" append-to-body class="ah-detail-dialog non-income-invoice-dialog">
            <template slot="title">
                <span>輸入備註並完成此發票</span>
            </template>

            <div class="detail-row" style="padding-top: 30px">
                <el-form ref="form">
                    <el-form-item>
                        <el-input v-model="editBankNote.value" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="請填寫無法回收帳款的說明"></el-input>
                    </el-form-item>
                </el-form>

                <div class="button-set">
                    <el-button type="" plain @click="onCloseNonIncomeInvoice"> 取消 </el-button>
                    <el-button type="primary" @click="onSubmitNonIncomeInvoice">
                        確認完成
                    </el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import DialogBlockWrapper from '@/components/ui/DialogBlock/DialogBlockWrapper.vue';

export default {
    props: {
        form: {
            type: Object,
            default: () => {},
        },
        isActionEnabled: Boolean,
    },
    components: { DialogBlockWrapper },
    computed: {
        remainAmt() {
            return this.form.amt - this.totalArrival;
        },
        totalReturn() {
            const SUM = _.chain(this.form.incomes)
                .filter((o) => o.flg < 0)
                .sumBy((o) => o.amount)
                .value();
            return SUM - this.totalFutureReturn;
        },
        totalReturnTwd() {
            const SUM = _.chain(this.form.incomes)
                .filter((o) => o.flg < 0)
                .sumBy((o) => o.amount * o.rat)
                .value();
            return SUM - this.totalFutureReturnTwd;
        },
        totalFutureReturn() {
            return _.chain(this.form.incomes)
                .filter((o) => o.flg < 0)
                .filter((o) => moment(o.bnK_DAT).isAfter(moment()))
                .sumBy((o) => o.amount)
                .value();
        },
        totalFutureReturnTwd() {
            return _.chain(this.form.incomes)
                .filter((o) => o.flg < 0)
                .filter((o) => moment(o.bnK_DAT).isAfter(moment()))
                .sumBy((o) => o.amount * o.rat)
                .value();
        },
        totalArrival() {
            return _.chain(this.form.incomes)
                .filter((o) => o.flg > 0)
                .sumBy((o) => o.amount)
                .value();
        },
        totalArrivalTwd() {
            return _.chain(this.form.incomes)
                .filter((o) => o.flg > 0)
                .sumBy((o) => o.amount * o.rat)
                .value();
        },
        toBeCreditedAmount() {
            const DIS_AMT = this.form.foO_DIS_CNL ? 0 : this.form.foO_DIS_AMT;
            return this.form.amt - this.totalArrival + this.totalReturn - DIS_AMT;
        },
        arrivalInfo() {
            const AUDITS = this.form.audits[1] || {};
            return {
                stF_NAM: AUDITS.stF_NAM,
                sdat: AUDITS.sdat,
            };
        },
    },
    data() {
        return {
            nonIncomeInvoiceVisible: false,
            editBankNote: { isEditMode: false, value: '' },

            arriveTypeList: {
                income: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 1, label: '收現金存銀行' },
                    { sno: 2, label: '收現金存零用金' },
                ],
                return: [
                    { sno: 0, label: '銀行匯款' },
                    { sno: 2, label: '零用現金退費' },
                ],
            },
        };
    },
    methods: {
        onCollapseChange(open) {
            if (!open) {
                this.onCancelEditBankNote();
            }
        },
        onEditBankNote() {
            this.editBankNote.isEditMode = true;
            this.editBankNote.value = this.form.bankNote;
        },
        async onSaveBankNote() {
            await this.$api({
                url: 'InvoiceManagemnetPage/UpdateBankNote',
                method: 'POST',
                data: {
                    InvoiceSno: this.form.sno,
                    banknote: this.editBankNote.value.trim(),
                },
            });
            this.onReload();
            this.editBankNote.isEditMode = false;
        },
        onCompleteNonIncomeInvoice() {
            this.nonIncomeInvoiceVisible = true;
        },
        onCloseNonIncomeInvoice() {
            this.nonIncomeInvoiceVisible = false;
        },
        onSubmitNonIncomeInvoice() {
            this.$emit('complete', async () => {
                await this.onSaveBankNote();
                this.editBankNote.value = '';
                this.onCloseNonIncomeInvoice();
            });
        },

        onCancelEditBankNote() {
            this.editBankNote.isEditMode = false;
        },

        onAddArrival(flg) {
            this.$emit('add', flg);
        },
        onEditArrival(form) {
            this.$emit('edit', form);
        },

        getReceiveIncomeTypeText(flg, typeSno) {
            const typeList = flg > 0 ? this.arriveTypeList.income : this.arriveTypeList.return;
            return _.find(typeList, ['sno', typeSno]).label;
        },

        onReload() {
            this.$emit('reload');
        },

        tableRowClassName({ row }) {
            if (row.flg < 0) return 'minus-row';
            return '';
        },
        toggleClass(event, className) {
            event.target.classList.toggle(className);
        },
    },
};
</script>

<style lang="scss" scoped>
.invoice-arrived-view {
    .info-block {
        display: flex;
        justify-content: flex-end;
    }
    .info-block {
        margin: 30px 0 10px 0;
        flex-direction: column;
        align-items: flex-end;
        > * {
            width: fit-content;
            display: flex;
            margin-bottom: 5px;
            &:last-child {
                margin-bottom: 0;
            }
            .money {
                width: 130px;
                margin-right: 10px;
                text-align: right;
            }
        }
        .return {
            color: #f00;
        }
    }
    .edit-btn {
        cursor: pointer;
        color: #888;
        /*
        width: 30px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        > * {
            width: 3px;
            height: 3px;
            border-radius: 50%;
            background-color: #c4c4c4;
            margin-right: 3px;
            transition: 0.3s;
            &:last-child {
                margin-right: 0;
            }
        }
        */

        &:hover {
            > * {
                color: #6f3dd9;
                // background-color: #6f3dd9;
            }
        }
    }

    .guide-img {
        display: block;
        width: 75%;
        max-width: 250px;
        margin: 0 auto;
    }
    .guide-title {
        font-size: 14pt;
        font-weight: bold;
        margin: 30px 0 12px 0;
    }
    .guide-description {
        font-size: 10pt;
    }
    .guide-actions {
        margin: 20px 0 0 0;

        .el-button {
            font-weight: bold;
        }
    }
}
</style>

<style lang="scss">
.invoice-arrived-view {
    .minus-row {
        .type,
        .money {
            color: #f00;
        }
    }
    .ah-tip img {
        margin-top: 5px;
    }
    .mem-text {
        color: #999;
        font-size: 9pt;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: pointer;

        &:hover {
            color: #000;
        }
        &.show-all {
            overflow: unset;
            white-space: pre-line;
        }
    }
}
.non-income-invoice-dialog {
    .el-dialog {
        max-width: 600px;
    }

    .button-set {
        display: flex;
        justify-content: center;
    }
}
</style>
